import { useEffect } from "react";

export const useSetPageTitle = (title: string)=>{
    useEffect(()=>{
        document.title = `${title} - Peptide Machines`;
    },[])// eslint-disable-line react-hooks/exhaustive-deps
}